export default function arrayMove<T>({
  array,
  fromIndex,
  toIndex,
}: {
  array: T[];
  fromIndex: number;
  toIndex: number;
}): T[] {
  const newArray = array.slice();
  newArray.splice(
    toIndex < 0 ? newArray.length + toIndex : toIndex,
    0,
    newArray.splice(fromIndex, 1)[0]
  );

  return newArray;
}
